import React from "react";
import { Link } from "react-router-dom";
import { Carousel, Row, Col } from "react-bootstrap";
import "./carouselBooks.css";
import { useState, useEffect } from 'react';

const ItemComponent =(props)=>{

  const { random, imgCss, imgStyles } = props;
  console.log("random.coverImage   ", random.coverImage)

  return (
    <Link 
          to={random.firstName? `/editorial/authors/${random._id}`: `/editorial/books/${random._id}`}
          style={{ textDecoration:'none', color:'#e71c24' }}
        >
      <div className="card gallery-item" style={{ width:"100%" }}>
            
        <img 
          alt={random.title} 
          className={`card-thumbnail-top ${imgCss}`}
          src={random.coverImage || '/assets/app/cover.jpg'} 
          style={imgStyles}
        />

        <div className="card-body" style={{ textAlign:'center' }}>
          
              {random.firstName? `${random.firstName} ${random.lastName}`: random.title}
        </div>
      </div>
    </Link>
  )
}

const CarouselBooks = ({ books }) => {
const [booksPerSlide, setBooksPerSlide] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setBooksPerSlide(1); // 1 libro por slide en pantallas pequeñas
      } else if (window.innerWidth < 992) {
        setBooksPerSlide(2); // 2 libros por slide en pantallas medianas
      } else {
        setBooksPerSlide(3); // 3 libros por slide en pantallas grandes
      }
    };

    handleResize(); // Llama a la función al montar el componente
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const slides = [];
  for (let i = 0; i < books.length; i += booksPerSlide) {
    const slideBooks = books.slice(i, i + booksPerSlide);
    slides.push(
      <Carousel.Item key={i}>
        <Row>
          {slideBooks.map((book) => (
            <Col key={book._id} className="itemCarousel">
              <ItemComponent
                key={book._id}
                random={book}
                imgStyles={{ height: '250px' }}
              />
            </Col>
          ))}
        </Row>
      </Carousel.Item>
    );
  }

  const showCarousel = books.length > booksPerSlide;

  return (
    <>
      {showCarousel ? (
        <Carousel
          variant="dark"
          interval={100000}
          indicators={false}
          style={{ minHeight: '400px' }}
        >
          {slides}
        </Carousel>
      ) : (
        <Row>
          {books.map((book) => (
            <Col key={book._id} className="itemCarousel">
              <ItemComponent
                key={book._id}
                random={book}
                imgStyles={{ height: '250px' }}
              />
            </Col>
          ))}
        </Row>
      )}
    </>
  );
};


export default CarouselBooks;
